import {
  checkExternalChatUserState,
  isExternalChatUserState,
  ExternalChatUserState,
} from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useDocumentStore } from "Helpers/StoreHelper";
import { useRef } from "react";
import { firestore } from "firebase/app";

export function useUserStateStore(userId: string) {
  const collectionRef = useRef(
    firestore().collection(CollectionPath.USER_STATES)
  );

  return useDocumentStore<ExternalChatUserState>({
    check: checkExternalChatUserState,
    is: isExternalChatUserState,
    collection: collectionRef.current,
    documentPath: userId,
  });
}
